
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class SettlementPdfDtoModel extends Model<SettlementPdfDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'owner', type: 'OwnerDtoModel', isHidden: true, isObject: true, new: () => { return new OwnerDtoModel }, properties: () => { return OwnerDtoModel.classProperties } },
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'productPlans', type: 'ProductPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'accountingPlans', type: 'AccountingPlanDtoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new AccountingPlanDtoModel }, properties: () => { return AccountingPlanDtoModel.classProperties } }
	];
	[key: string]: any;
	
	public owner?: OwnerDtoModel;
	public company?: CompanyModel;
	public productPlans: ProductPlanModel[];
	public accountingPlans: AccountingPlanDtoModel[];
    
	constructor(){
		super();
		this.owner = undefined;
		this.company = undefined;
		this.productPlans = [];
		this.accountingPlans = [];
		
	}
	getProperties(){
		return SettlementPdfDtoModel.classProperties;
	}
}
export class OwnerDtoModel extends Model<OwnerDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string' },
		{ name: 'vatNumber', type: 'string' },
		{ name: 'address', type: 'string' },
		{ name: 'zipcode', type: 'string' },
		{ name: 'city', type: 'string' },
		{ name: 'bankName', type: 'string' },
		{ name: 'bankReg', type: 'string' },
		{ name: 'bankAccount', type: 'string' }
	];
	[key: string]: any;
	
	public name: string;
	public vatNumber: string;
	public address: string;
	public zipcode: string;
	public city: string;
	public bankName: string;
	public bankReg: string;
	public bankAccount: string;
    
	constructor(){
		super();
		this.name = '';
		this.vatNumber = '';
		this.address = '';
		this.zipcode = '';
		this.city = '';
		this.bankName = '';
		this.bankReg = '';
		this.bankAccount = '';
		
	}
	getProperties(){
		return OwnerDtoModel.classProperties;
	}
}
export class AccountingPlanDtoModel extends Model<AccountingPlanDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'accountingPlanId', type: 'string' },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'startDate', type: 'Date' },
		{ name: 'endDate', type: 'Date' },
		{ name: 'totalPlanValue', type: 'number' },
		{ name: 'invoicedValue', type: 'number' }
	];
	[key: string]: any;
	
	public accountingPlanId?: string;
	public productPlanId?: string;
	public startDate?: Date;
	public endDate?: Date;
	public totalPlanValue: number;
	public invoicedValue: number;
    
	constructor(){
		super();
		this.accountingPlanId = undefined;
		this.productPlanId = undefined;
		this.startDate = undefined;
		this.endDate = undefined;
		this.totalPlanValue = 0;
		this.invoicedValue = 0;
		
	}
	getProperties(){
		return AccountingPlanDtoModel.classProperties;
	}
}

